import axios from "axios";
import { useEffect } from "react";

import { getToken, removeToken } from "../lib/authentication";

export default function Logout(params) {
  useEffect(() => {
    const logout = async () => {
      try {
        await axios.post(
          `${process.env.REACT_APP_BASE_URL}auth/logout/`,
          {},
          {
            headers: {
              Authorization: `Token ${getToken()}`,
            },
          }
        );
      } catch (e) {
        // It's fine, we're logging out anyway.
      }
      removeToken();
      window.location.href = "/";
    };

    logout();
  });

  return <>Logging you out now.</>;
}
